import { Box, Typography } from '@mui/material';
import React from 'react';
import NStyles from './Notifications.module.css';
import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';

import useAuth from '../../hooks/useAuth';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';



function Notifications() {

  const {openBackdrop,closeBackdrop,BackdropComponent}=useBackdrop();
  
  const {auth}=useAuth();

  useEffect(() => {

  }, [])

  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();
  if (day < 10) {
    day = "0" + day
  }

  if (month < 10) {
    month = "0" + month
  }
  const todayDate = year + "-" + month + '-' + day;


  const handleDate = (date) => {
    const dday = date.split('-');

    if (date === todayDate) {
      return "Today"
    }
    else if ((day - dday[3]) === 1) {
      return "Yesterday"
    }
    else {
      return date;
    }
  }

  const [notifications,setNotifications]=useState([]);



  const separateDate = (gdate) => {
    const [dateString, timeString] = gdate.split("T");

    // console.log(gdate.split("T"))
    const date = dateString;

    const time = timeString.substr(0, 8);


    return [date, time]
  }

  const fetchNotifications = async () => {
    openBackdrop()
    try {
      const name =auth.name;
      // console.log(datas )
      const res = await axios.get(`${process.env.REACT_APP_COSMOSADMIN}/notification/getAllNotification`,
        {
          headers: {
            "Accept": "*/*"
          }
        })
      const data = res.data.map((notifi) => {
        return (
          {
            date: separateDate(notifi.date)[0],
            name: name,
            time: separateDate(notifi.date)[1],
            details: notifi.notifcationMessage,
            id: notifi.id,
          }
        )
      })
  
  
        setNotifications(data);
    } catch (error) {
        console.log("error",error)
    }
    closeBackdrop();
  }

  useEffect(() => {
    fetchNotifications();
  }, [])




  // TODO: make an endpoint where the user can hit the api and can post data which will have the dataobj which is notificationDataObj
  // so every click where you want a notification to be you post this obj to the api and save it in the database
  //  
  const noticationgrup = notifications
    .reduce((groups, notification) => {
      let date = handleDate(notification.date);
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(notification);
      return groups;
    }, {})


  // console.log(noticationgrup);
  return (
    <>
    <BackdropComponent/>
    <div className={NStyles.NotificationsMain}>
      <Box className={NStyles.NotificationsContainer}>
        <Typography variant="h2">Notifications</Typography>

        {/* Map over the notificationsData array */}
        {
          Object.keys(noticationgrup).reverse().map(date => {

            const noti = noticationgrup[date];
            return (
              <>
                <Typography variant="h3">{date}</Typography>
                {
                  noti.map((notification, index) => {
                    return (
                      <>
                        <Box key={index} // Use a unique key for each item in the array
                          className={NStyles.NotificationsAlert}
                          sx={{ alignItems: { xs: 'baseline', sm: 'baseline', md: 'center', lg: 'baseline' }, }}
                        >
                          <Box className={NStyles.AlertMain}>
                            <Typography variant="h4"
                              sx={{
                                flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row !important' },
                                width: { xs: '80%', md: '80%' },
                              }}
                            >
                              {notification.name}
                              <span>{notification.details}</span>

                            </Typography>
                          </Box>
                          <Typography variant="h6">{notification.time}</Typography>
                        </Box>
                      </>
                    )
                  }).reverse()}
              </>
            )
          })
        }

      </Box>
    </div>
    </>
  );
}

export default Notifications;




